import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';

import { useRegisterStepGate } from '../../../hooks';
import { WizardStep } from '../../../PrepareDisclosuresWizard.constants';

import {
  ESIGN_ONLY_DELIVERY_DISCLAIMER,
  MAIL_PROVIDER_DELIVERY_DISCLAIMER,
} from './borrowersDelivery.constants';
import {
  cardsRowStyles,
  disclaimerIconStyles,
  disclaimerStyles,
  disclaimerTextStyles,
  layoutStyles,
  sectionHeaderStyles,
  signerListStyles,
} from './BorrowersDeliveryStep.styles';
import { BorrowersDeliveryStepTestIds } from './BorrowersDeliveryStep.testIds';
import EarliestClosingImpactCard from './components/EarliestClosingImpactCard';
import IntentToProceedCard from './components/IntentToProceedCard';
import SignerRow from './components/SignerRow';
import { useBorrowersDelivery } from './hooks';

const BorrowersDeliveryStep = () => {
  const { signers, isValid, ecdEstimate, intentToProceed, updateDelivery, isMailProviderEnabled } =
    useBorrowersDelivery();

  useRegisterStepGate(WizardStep.BORROWERS_DELIVERY, isValid);

  return (
    <Box data-testid={BorrowersDeliveryStepTestIds.ROOT} sx={layoutStyles}>
      <Typography sx={sectionHeaderStyles} variant="bold12">
        Signers &amp; delivery method
      </Typography>

      <Box data-testid={BorrowersDeliveryStepTestIds.DISCLAIMER} sx={disclaimerStyles}>
        <Box sx={disclaimerIconStyles}>
          <InfoIcon size={16} />
        </Box>
        <Typography sx={disclaimerTextStyles} variant="regular12">
          {isMailProviderEnabled
            ? MAIL_PROVIDER_DELIVERY_DISCLAIMER
            : ESIGN_ONLY_DELIVERY_DISCLAIMER}
        </Typography>
      </Box>

      <Box data-testid={BorrowersDeliveryStepTestIds.SIGNER_LIST} sx={signerListStyles}>
        {signers.map(signer => (
          <SignerRow
            ecdEstimate={ecdEstimate}
            key={signer.signerKey}
            signer={signer}
            onDeliveryChange={updateDelivery}
          />
        ))}
      </Box>

      <Typography
        data-testid={BorrowersDeliveryStepTestIds.NBE_NOTE}
        sx={disclaimerTextStyles}
        variant="regular12"
      >
        Additional signers (non-borrowing entities) are managed on the loan before preparing
        disclosures.
      </Typography>

      <Box sx={cardsRowStyles}>
        <IntentToProceedCard status={intentToProceed.status} />
        <EarliestClosingImpactCard
          ecdEstimate={ecdEstimate}
          isMailProviderEnabled={isMailProviderEnabled}
        />
      </Box>
    </Box>
  );
};

export default memo(BorrowersDeliveryStep);
